import {RootState} from "../redux/store";
import {TAsset} from "../types";

const selectSelectedRows = (state: RootState): TAsset[] => state.assets.selectedRows;

export {
    selectSelectedRows,
}
